const types = {
	//Get Template name
	GET_EQUIPMENTFORMLIST_START: "GET_EQUIPMENTFORMLIST_START",
	GET_EQUIPMENTFORMLIST_SUCCESS: "GET_EQUIPMENTFORMLIST_SUCCESS",
	GET_EQUIPMENTFORMLIST_ERROR: "GET_EQUIPMENTFORMLIST_ERROR",
	GET_EQUIPMENTFORMLIST_RESET: "GET_EQUIPMENTFORMLIST_RESET",

	//single item  name
	SELECT_TOUPDATE_ITEM: "SELECT_TOUPDATE_ITEM",
};

export default types;
